<template>
  <!-- 客户提现记录 -->
  <div class="opage">
    <div>
      <!-- 出入金明细 -->
      <baseBreadcrumb :page="$t('message.moneyManagement')" :menu="$t('message.withdrawalHistory')"></baseBreadcrumb>
      <!-- 搜索 -->
      <div class="body">
        <div class="search">
          <div class="row">
            <!-- 开始日期-->
            <div class="item">
              <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.startDate')" class="Container"
                type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
              </el-date-picker>
            </div>
            <!--  结束日期-->
            <div class="item">
              <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')" class="Container"
                default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
              </el-date-picker>
            </div>
            <!-- 搜索 -->
            <el-button type="primary" @click="search">
              {{ $t("message.search") }}
            </el-button>
            <!-- 重置 -->
            <el-button @click="reset">
              {{ $t("message.reset") }}
            </el-button>
          </div>
          <div class="operation">
            <!-- 导出EXCEL -->
            <span type="primary" @click="handleExportExcel" class="btns">{{ $t('message.exportExcel') }}</span>

          </div>
        </div>
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!-- 发起时间 -->
            <li class="flex15">{{ $t('message.initiationTime') }}</li>
            <!-- 银行名 -->
            <li>
              {{ $t('message.bankName') }}
            </li>
            <li>
              支店番号
            </li>
            <li>支店名</li>
            <li>口座番号</li>
            <li>口座名羲</li>
            <!-- 处理状态 -->
            <li>{{ $t('message.processingStatus') }}</li>
            <!-- 明细 -->
            <li>{{ $t('message.theDetail') }}</li>
            <!-- 操作 -->
            <li>{{ $t('message.operation') }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li class="flex05">{{ index + 1 }}</li>
            <!-- 发起时间 -->
            <li class="flex15">{{ item.created_at }}</li>

            <li>
              <!-- {{ $t('message.theNumberOfTheFlow') }} -->
              {{ item.client_bank_name }}
            </li>
            <li>
              {{ item.client_bank_branch_no }}</li>
            <li>{{ item.client_bank_branch_name }}</li>
            <li>{{ item.client_account }}</li>
            <li>{{ item.client_bank_username }}</li>
            <!-- 处理状态 -->
            <li>{{ item.status_name }}</li>
            <!-- 明细 -->
            <li>{{ item.client_reason }}</li>
            <!-- 操作 -->
            <li>
              <!-- 查看凭证 -->
              <router-link v-if="item.pay_image" :to="item.pay_image" target="_blank">
                {{ $t('message.reviewTheCredentials') }}
              </router-link>
            </li>
          </ul>
          <!-- 暂无数据 -->
          <div v-if="tableData == false" class="No_data">{{ $t('message.noDataYet') }}</div>
        </div>
        <!-- 分页 -->
        <div class="paginationContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
            :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      num: 0,
      datas: {
        user_id: this.$route.query.userID,
      },
      tableData: [],
      total: 0,
      checked: false,
      checkNum: 0, // 已选商品番数
      chioseIdArr: [],
      billType: [],
      billMethod: []
    };
  },
  component: {},
  created() {
    this.cashList();
  },
  methods: {
    // excel导出
    handleExportExcel() {
      let datasNew = JSON.parse(JSON.stringify(this.datas))
      datasNew.pageSize = 99999999
      this.$api.clienteleApi.cashList(datasNew).then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        let excelData = res.data.data
        require.ensure([], () => {
          const { export_json_to_excel } = require("@/utlis/Export2Excel");
          const tHeader = [
            // 发起时间
            this.$t('message.confirmTheCreditingTime'),
            // 流水号
            this.$t('message.theNumberOfTheFlow'),
            // 收款户名
            this.$t('message.beneficiaryName'),
            // 收款户号
            this.$t('message.beneficiaryAccountNumber'),
            // 提现金额
            this.$t('message.withdrawalAmount'),
            // 处理状态
            this.$t('message.processingStatus'),
            // 明细
            this.$t('message.theDetail'),
          ];
          const filterVal = [
            'created_at',
            'serial_number',
            'client_name',
            'client_account',
            'client_amount',
            'status_name',
            'client_reason'
          ];
          const list = excelData; //把data里的tableData存到list
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, "客户提现记录");
        });
        this.total = res.data.total;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },


    // 重置
    reset() {
      this.datas = {
        user_id: this.$route.query.userID,
      };
      this.cashList();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.cashList();
    },
    // 获取配送单列表
    cashList() {
      this.$api.clienteleApi.cashList(this.datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.cashList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.cashList();
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin: 24px 0;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 240px;
      margin-right: 24px;
    }
  }

  .operation {
    display: flex;
    justify-content: center;
    align-items: center;

    >* {
      margin-bottom: 26px;
    }
  }
}

.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.flex05 {
  flex: 0.5;
}

.flex15 {
  flex: 1.5;
}

.flex2 {
  flex: 2;
}

.readOnly {
  pointer-events: none;
}

.blurFont {
  color: blue;
}

.redFont {
  color: red;
}

.table {
  font-size: 14px;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
    word-break: break-all;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex1 {
    flex: 1;
  }

  .flex2 {
    flex: 2;
  }

  .flex15 {
    flex: 1.5;
  }

  .important {
    background-color: #e0e7f7;
    max-height: 100px;
    overflow: hidden;
  }

  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;
    height: 100px;

    &:hover {
      background-color: #fff;
    }

    /deep/ .el-input__inner {
      padding: 0;
      text-align: center;
    }
  }
}

.showDetail {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    max-width: 86%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.btns {
  color: red;
  text-decoration: underline;
  background-color: transparent;
  margin: 0;
  padding: 0;
  cursor: pointer;
}
</style>
